import { createContext } from 'react';
var HeadingContext = /*#__PURE__*/createContext(0);
export { HeadingContext as H };